import { MouseEvent, useState } from 'react';

export type ProviderAddAction = 'contract' | 'contact' | 'reminder';

export function useProviderAddActions() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [activeModal, setActiveModal] = useState<ProviderAddAction | null>(null);

  function handleOpenMenu(event: MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleCloseMenu() {
    setAnchorEl(null);
  }

  function handleSelectAction(action: ProviderAddAction) {
    setAnchorEl(null);
    setActiveModal(action);
  }

  function handleCloseModal() {
    setActiveModal(null);
  }

  return {
    anchorEl,
    isMenuOpen: Boolean(anchorEl),
    activeModal,
    handleOpenMenu,
    handleCloseMenu,
    handleSelectAction,
    handleCloseModal,
  };
}
